export default class UserCreditCardController {
  constructor(resource) {
    this._resource = resource;
  }

  changePattern(cardId) {
    return this._resource(`creditCard/pattern/${cardId}`)
      .update()
      .then((res) => res.body)
      .catch((e) => {
        throw e;
      });
  }

  async getAllByUserId(userId, onlyValidated = false) {
    return this._resource(`creditCard`, {
      userId,
      onlyValidated,
    })
      .get()
      .then((res) => res.body)
      .catch((e) => {
        throw e;
      });
  }

  async create(card) {
    try {
      let response = await this._resource(`creditCard`).save(card);
      return {
        ok: true,
        message: response.body,
      };
    } catch (error) {
      console.log(error);
      return {
        ok: false,
        message: error.body.erro,
      };
    }
  }

  async createByAdm(card) {
    try {
      let response = await this._resource(`creditCard-by-adm`).save(card);
      return {
        ok: true,
        message: response.body,
      };
    } catch (error) {
      console.log(error);
      return {
        ok: false,
        message: error.body.erro,
      };
    }
  }

  async delete(id_card) {
    try {
      let response = await this._resource(`creditCard/${id_card}`).delete();
      return response.body;
    } catch (error) {
      return (result = {
        ok: false,
        message: 'error',
      });
    }
  }
  updatePattern(userCreditCardId) {
    return this._resource(`creditCard/pattern/${userCreditCardId}`)
      .update()
      .then((res) => res.body)
      .catch((error) => console.log(error));
  }
}
